document.addEventListener('click',e=>{
  const t=e.target.closest('[data-menu-toggle]');
  if(t){document.querySelector('[data-mobile-menu]')?.classList.toggle('is-open');}
  const tab=e.target.closest('[data-menu-tab]');
  if(tab){
    const group=tab.closest('[data-menu-section]');
    group?.querySelectorAll('[data-menu-tab]').forEach(x=>x.classList.remove('is-active'));
    tab.classList.add('is-active');
    const cat=tab.dataset.menuTab;
    group?.querySelectorAll('[data-menu-item]').forEach(item=>{item.hidden=cat!=='all'&&item.dataset.menuItem!==cat;});
  }
  const pageTab=e.target.closest('[data-menu-page-tab]');
  if(pageTab){
    const page=pageTab.closest('.s69-menu-page');
    page?.querySelectorAll('[data-menu-page-tab]').forEach(x=>x.classList.remove('is-active'));
    pageTab.classList.add('is-active');
    const cat=pageTab.dataset.menuPageTab;
    page?.querySelectorAll('[data-menu-page-panel]').forEach(panel=>{panel.hidden=panel.dataset.menuPagePanel!==cat;});
  }
});
